import { render } from "./Cheats.vue?vue&type=template&id=304ed07a&ts=true"
import script from "./scripts/cheats.ts?vue&type=script&lang=ts"
export * from "./scripts/cheats.ts?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__